export const getGender = () => {
  const genderList = [
    {
      label: 'Male',
      value: '0',
    },
    {
      label: 'Female',
      value: '1',
    }
  ];

  return genderList;
};